/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import moment from 'moment';

import { withTranslation } from 'providers/GILT.provider';

import TimePickerBtn from 'onboarding/common/forms/checkboxPopup/TimePickerBtn';

class Switcher extends React.Component {
  static defaultProps = {
    onOpenCheckboxChange: () => {},
    onOpenTimeChange: () => {},
    onCloseTimeChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      checked: props.isOpen,
      openingHours: [],
      closingHours: [],
    };
  }

  UNSAFE_componentWillMount() {
    this.generateHours(this.props.openTime);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.openTime.format('hh:mm a') !== newProps.openTime.format('hh:mm a')) {
      this.generateHours(newProps.openTime);
    }
  }

  onOpenTimeChange = (newTime) => {
    if (this.props.onOpenTimeChange) {
      this.props.onOpenTimeChange(this.props.dayName, newTime);
    }
  };
  onCloseTimeChange = (newTime) => {
    if (this.props.onCloseTimeChange) {
      this.props.onCloseTimeChange(this.props.dayName, newTime);
    }
  };
  onCheckboxClick = () => {
    this.setState({ checked: !this.state.checked }, () => {
      if (this.props.onOpenCheckboxChange) {
        this.props.onOpenCheckboxChange(this.props.dayName, this.state.checked);
      }
    });
  };
  generateHours = (openTime) => {
    const minimumOpeningTime = '07:00 am';
    const minimumClosingTime = openTime.format('hh:mm a');
    const openingHours = [];
    const closingHours = [];
    let hour = minimumOpeningTime;
    let i = 0;
    let addClosingHours = false;
    do {
      openingHours.push({
        id: i,
        name: hour,
      });
      if (addClosingHours) {
        closingHours.push({
          id: i,
          name: hour,
        });
      }
      if (hour === minimumClosingTime) {
        addClosingHours = true;
      }
      hour = moment(hour, 'hh:mm a')
        .add(15, 'minutes')
        // .local()
        .format('hh:mm a'); // ("LT")
      i += 1;
    } while (hour !== '10:15 pm');
    this.setState({ openingHours, closingHours });
  };

  render() {
    const { dayName, openTime, closeTime, t } = this.props;

    let activeColor = '#080b0f'; // black
    if (!this.state.checked) {
      activeColor = '#ccc'; // gray
    } else {
      activeColor = '#080b0f';
    }

    return (
      <div className="row">
        <div className="time-input-wrap clearfix col-lg-8">
          <div className="checkbox-switch-wrap">
            <input type="checkbox" className="checkbox-switch" id={dayName} checked={this.state.checked} onChange={this.onCheckboxClick} />
            <label style={{ color: activeColor }} htmlFor={dayName}>
              {dayName}
            </label>
          </div>
          {this.state.checked && (
            <div>
              <div className="left-btn">
                <TimePickerBtn
                  label={t('register.openingHoursWrap.from')}
                  popupTitle={t('register.openingHoursWrap.openingHoursFrom', { dayName })}
                  defaultTime={openTime}
                  dayName={dayName}
                  onOpenTimeChange={this.onOpenTimeChange}
                  hoursToShow={this.state.openingHours}
                />
              </div>
              <div className="right-btn">
                <TimePickerBtn
                  label={t('register.openingHoursWrap.to')}
                  popupTitle={t('register.openingHoursWrap.closingHoursTo', { dayName })}
                  defaultTime={closeTime}
                  dayName={dayName}
                  onCloseTimeChange={this.onCloseTimeChange}
                  hoursToShow={this.state.closingHours}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Switcher);
